export var TranslationUtilProvider;
(function (TranslationUtilProvider) {
    TranslationUtilProvider[TranslationUtilProvider["NONE"] = 0] = "NONE";
    TranslationUtilProvider[TranslationUtilProvider["WEGLOT"] = 1] = "WEGLOT";
    TranslationUtilProvider[TranslationUtilProvider["LANGIFY"] = 2] = "LANGIFY";
    TranslationUtilProvider[TranslationUtilProvider["NATIVE"] = 3] = "NATIVE";
})(TranslationUtilProvider || (TranslationUtilProvider = {}));
export var TranslationUtilStringProvider;
(function (TranslationUtilStringProvider) {
    TranslationUtilStringProvider["NONE"] = "";
    TranslationUtilStringProvider["LANGIFY"] = "langify";
    TranslationUtilStringProvider["WEGOLT"] = "wegolt";
    TranslationUtilStringProvider["NATIVE"] = "native";
})(TranslationUtilStringProvider || (TranslationUtilStringProvider = {}));
//# sourceMappingURL=provider.js.map